import {default as React, useEffect, useState} from 'react';
import './assets/css/font-awesome.min.css';
import "./assets/css/bootstrap.min.css"
import './assets/css/whatschat-layout.css';
import './assets/css/colors/color-green.css';
import {default as Wp8} from "./components/wp8";
import {default as Wp2} from "./components/wp2";

const App = () => {
    const [config,setConfig] = useState(0);
    const onEventClick = (phone,keyword) => {
        try {
            const url = document.referrer;
            if(url) {
                window.parent.postMessage(JSON.stringify({event:"onClick", phone, keyword}),url);
            }
        } catch (e) {
            console.error(e);
        }
    }
    const onResize = (event) => {
        try {
            const url = document.referrer;
            if(url) {
                window.parent.postMessage(JSON.stringify({event:"resizeEvent",size: event}),url);
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(()=>{
        window.onmessage = (event)=>{
            const converted = JSON.parse(event.data);
            switch (converted.event) {
                case "init":{
                    setConfig(converted.content);
                    break;
                }
                default:
                    break;
            }
        }
    },[]);

    return (
        <>
            {config.type === 8 && <Wp8 data={config.data} onChangeResize={onResize} onClickEvent={onEventClick}/>}
            {config.type === 2 && <Wp2 {...config.data} onChangeResize={onResize} onClickEvent={onEventClick}/>}
        </>
    );
};

export default App;
